export const defaultLocale = 'en'
export const locales = [{
        code: 'en',
        name: 'english',
        dir: 'ltr',
    },
    {
        code: 'de',
        name: 'Deutsch',
        dir: 'ltr',
    },
    // {
    //     code: 'ja',
    //     name: '日本語',
    //     dir: 'ltr'
    // },
    // {
    //     code: 'ru',
    //     name: 'русский',
    //     dir: 'ltr'
    // },
]


// WEBPACK FOOTER //
// ./src/locales.js